// 专注于Link的处理
import React, { useEffect, useRef, useState } from "react";
import { IComponentLink } from "../../component";
import { navigatorTo } from "../../utils/util";
import { appendCurrentShareRouteParams } from "../../utils/shareMeta";
import { isInMiniProgram } from "utils/mini_program";

const fixedUrl = (link?: string | IComponentLink, redirect?: boolean) => {
  let url = "";
  if (!link) {
    console.warn("link is null here");
    return url;
  }
  if (typeof link === "string") {
    url = link;
  } else if (link && link.url_labeling) {
    url = "/gti/" + link.url_labeling;
  } else if (link && link.galleryid && Number(link.galleryid) < 1000000) {
    url = "//wx" + window.__basename + "/gallery?id=" + link.galleryid;
  } else {
    url = navigatorTo(link, true, redirect);
  }

  return redirect ? url : appendCurrentShareRouteParams(url);
};

const getOpenMiniappHtml = (rect: number[], appid: string, path: string) => {
  return `<wx-open-launch-weapp appid="${appid}" path="${path}" style="width:${rect[0]}px;height:${rect[1]}px;">
    <script type="text/wxtag-template">
      <style>
        .wx-btn{
          width:${rect[0]}px;
          height:${rect[1]}px;
        }
      </style>
      <div class="wx-btn"></div>
    </script>
  </wx-open-launch-weapp>`;
}

const ComponentLink = {
  to: function (link?: string | IComponentLink, redirect?: boolean) {
    let url = fixedUrl(link, redirect);
    !!url && (window.location.href = url);
  },
  replace: function (link?: string | IComponentLink) {
    let url = fixedUrl(link);
    !!url && window.location.replace(url);
  },
  Wrapper:(props:any)=>{
    const {link, children, placeImage, lunchId} = props;

    const domRef = useRef<HTMLDivElement>(null);
    const [rect, setRect] = useState([0, 0]);

    useEffect(()=>{
      const onRectChange = ()=>{
        if(domRef && domRef.current) {
          setRect([domRef.current.offsetWidth, domRef.current.offsetHeight]);
        }
      };

      const resizeObserver = window.ResizeObserver ? new window.ResizeObserver(entries => {
        onRectChange();
      }) : null;

      if(domRef && domRef.current) {
        onRectChange();
        if(resizeObserver) {
          //监听对应的dom
          resizeObserver.observe(domRef.current);
        }
      }

      return ()=>{
        if(resizeObserver && domRef && domRef.current) {
          resizeObserver.unobserve(domRef.current);
        }
      }
    }, [domRef]);
    
    const canUseMiniProgram = isInMiniProgram() || window.isweixin;
    if(link && link.type == 'miniprogram' && canUseMiniProgram) {
      return <div ref={domRef}>
        {children}
        <div style={{position:`absolute`, top:0, left:0, zIndex:10, opacity:0, width:`100%`, height:`100%`, border:`1px solid green`}}
          dangerouslySetInnerHTML={{__html:getOpenMiniappHtml(rect, link.appid, link.path)}}
        >
          {/* <wx-open-launch-weapp
            appid={link.appid}
            path={link.path}
            style={{paddingRight:`100%`, paddingBoggom:`100%`}}
          >
            <script type="text/wxtag-template">
              <img src={placeImage.indexOf(`http`) < 0 ? `https:${placeImage}` : placeImage} style={{width:`100vw`,height:`100vh`,border:`1px solid #000`}} />
            </script>
          </wx-open-launch-weapp> */}

        </div>
        {/*注意，需要最小宽度，否则容易出现字换行的情况， white-space:nowrap也无法解决*/}
        {/*<img src={placeImage} style={{width:`100%`}} />*/}
      </div>
    }else {
      return children;
    }
  }
};

export default ComponentLink;
